export default "__VITE_ASSET__DmBU1_So__"